import { useState, useEffect, useRef } from "react";
import { jsx } from "react/jsx-runtime";
import "./Discography.css";
import { ParallaxProvider } from "react-scroll-parallax";

function Discography() {
  const [backgroundImage, setBackgroundImage] = useState("./music/hanabi.jpg");
  const [scrollPosition, setScrollPosition] = useState(0);
  const discographyRef = useRef(null);

  const musicNames = [
    "ハジメテ",
    "山月記",
    "Summer Valentine",
    "スキ?キライ?Q&A",
    "花火",
    "花火-Grand End-",
    "12=3×4(進む)",
    "ちいさなちいさな恋のうた",
    "星空に願いを",
    "告白",
    "叫ぶ",
    "始まりのファンファーレ",
    "もはや何も言うまい",
    "夕焼けの約束",
  ];

  const images = [
    "./music/hajimete.webp",
    "./music/sangetuki.jpg",
    "./music/summerValentine.png",
    "./music/suki.jpg",
    "./music/hanabi.jpg",
    "./music/hanabi_grand.webp",
    "./music/12.png",
    "./music/ciisanaciisana.png",
    "./music/hosizora.jpg",
    "./music/kokuhaku.jpg",
    "./music/sakebu.jpg",
    "./music/fanfare.png",
    "./music/mohaya.png",
    "./music/yuuyake.png",
  ];

  const captions = [
    "記念すべき第一作。",
    "誰か俺の詩を聞いてくれ。そう叫んでも届かない。毛皮を濡らして走る。月に向かい吠えた――。",
    "僕と君が出会えたこと、そんなことにありがとう。",
    "記念すべき初配信楽曲。",
    "ドン、と花火が上がる。君は上を見る。私はこっそり、隣の君を見てた――。",
    "一人で仰ぐ花火は、どこか滲んでいて。",
    "また一つ何かを失くして、前へ前へ進んでいく。",
    "恥ずかしいからこんな歌でしか、君に好きと言えない。",
    "君が指さす先、流れ星ひとつ。",
    "この気持ちに嘘なんてつかずに、「大好き」だと伝えられたらな――。ノベルゲーム「0」主題歌。",
    "だけども僕らは、生きなきゃいけない。",
    "夢のままでは終わらせない、全部本当にしてやろう。「VRChat BOAT RACE」公式テーマソング。",
    "今頃になってあなたの前で「ありがとう」なんて恥ずかしくて。",
    "沈む夕陽の事を、二人会う理由にした。「BOAT RACE 眞白」スタート、周回展示曲。",
  ];

  const urls = [
    "https://youtu.be/lg7m8xNzFCQ?si=hZn6uqj3xRn95Xe7",
    "https://youtu.be/VYmllhQDQqI?si=YXUGKA1E-lEKIsCK",
    "https://youtu.be/ImAnCdCr16s?si=YmmmGPHrRVaR46bn",
    "https://www.tunecore.co.jp/artists/bugs_love",
    "https://youtu.be/3U5ZkFKm0fE?si=HxaVisB2SXWbud1D",
    "https://youtu.be/1eCc3CU2nrY?si=-jYwos1upiostisS",
    "https://youtu.be/1Y7b2bX1k1o?si=1b0j1Yk2f2YqT3oV",
    "https://youtu.be/WN4TL2f6IYY?si=xhQzRKDZnJ-TGUSi",
    "https://youtu.be/CcSkMuRFFG4?si=4kkRge3J1waQj083",
    "https://youtu.be/bt4TB0F4Duw?si=K2gSFTTTKgcIp3EW",
    "https://youtu.be/jS741f32-Ss?si=f43XFbRE4XzzJthF",
    "https://youtu.be/8frNxax1JuE?si=WaWCzVp1Y04DElIe",
    "https://youtu.be/cBZGYZt_I08?si=aRJq0DA3rIJeoMmB",
    "https://youtu.be/2CYoPMR6VQE",
  ];
  useEffect(() => {
    const handleScroll = () => {
      if (!discographyRef.current) return;

      const items =
        discographyRef.current.querySelectorAll(".discography-item");
      const scrollY = window.scrollY;
      setScrollPosition(scrollY);

      // 各アイテムの中心位置を計算し、最も近いものを見つける
      let closestIndex = 0;
      let closestDistance = Infinity;
      const viewportCenter = scrollY + window.innerHeight / 2;

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const itemTop = rect.top + scrollY;
        const itemHeight = rect.height;
        const itemCenter = itemTop + itemHeight / 2;
        const distance = Math.abs(viewportCenter - itemCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      console.log(`Current scroll: ${scrollY}, Closest: ${closestIndex} - ${musicNames[closestIndex]}`);

      // 最も近いアイテムに背景を適用してactiveclassを付与
      items.forEach((item, index) => {
        if (index === closestIndex) {
          setBackgroundImage(images[index]);
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // 初期実行

    // デバッグ用ログ
    setTimeout(() => {
      const items = discographyRef.current?.querySelectorAll(".discography-item");
      console.log("Total items:", items?.length);
      console.log("Total musicNames:", musicNames.length);
      console.log("Total images:", images.length);
      console.log("Total captions:", captions.length);
      console.log("Total urls:", urls.length);
    }, 100);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
    <title>Discography</title>
    <ParallaxProvider>
      <div
        className="discography-container"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundAttachment: "fixed",
        }}
      >
        <div className="discography">
          <h1>Discography</h1>
          <h3>今までに制作した作品を取り上げていきます。</h3>
        </div>

        <div className="discography-content" ref={discographyRef}>
          {musicNames.map((name, index) => (
            <a href={urls[index]} target="_blank" rel="noopener noreferrer">
            <div
              key={index}
              className="discography-item"
              data-image={images[index]}
            >
              <div className="item-content">
                <img src={images[index]} alt={name} className="item-image" />
                <div className="item-info">
                  <h2>{name}</h2>
                  <p>{captions[index] || ""}</p>
                </div>
              </div>
            </div>
            </a>
          ))}
        </div>
      </div>
    </ParallaxProvider>
  
    </>
  );
}
export default Discography;
